import {
  CREATE_INITIATIVES_REQUEST,
  CREATE_INITIATIVES_SUCCESS,
  CREATE_INITIATIVES_FAILED,
  GET_FORM_OPTIONS_REQUEST,
  GET_FORM_OPTIONS_SUCCESS,
  GET_FORM_OPTIONS_FAILED,
} from './actionTypes';

const initialState = {
  loading: false,
  error: null,
};

const createInitiativeReducer = (state = initialState, {
  type, error,
}) => {
  switch (type) {
    case CREATE_INITIATIVES_REQUEST:
      return { ...state, loading: true };
    case CREATE_INITIATIVES_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CREATE_INITIATIVES_FAILED:
      return { ...state, loading: false, error };
    case GET_FORM_OPTIONS_REQUEST:
      return { ...state, loading: true };
    case GET_FORM_OPTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_FORM_OPTIONS_FAILED:
      return { ...state, loading: false, error };
    default:
      return state;
  }
};

export default createInitiativeReducer;
